'use client'
import { Form } from '@/components/form/form-provider'
import { setGuestEmailAction } from '@/features/orders/services'
import { setPaymentAndPlaceOrderAction } from '@/services'
import { useAccountStore, useCartStore } from '@/store'
import yup from '@/utils/yup-global'
import { checkoutStep1Schema } from '@/validations'
import { yupResolver } from '@hookform/resolvers/yup'
import isEmpty from 'lodash/isEmpty'
import { useRouter } from 'next/navigation'
import { useState, useTransition } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { InforOrder } from './infor-order'

export const CheckoutPage = () => {
  const method = useForm<yup.InferType<typeof checkoutStep1Schema>>({
    resolver: yupResolver(checkoutStep1Schema),
  })
  const { handleSubmit, control, watch, reset, setValue, setError } = method
  const { data: userInfo } = useAccountStore()
  const [isPending, startTransition] = useTransition()
  const [dataPlaceOrder, setDataPlaceOrder] = useState<TPlaceOrderRes | undefined>()
  const router = useRouter()
  const [shippingMethod, setShippingMethod] = useState<{ method_code?: string; carrier_code?: string }>()
  const [paymentMethod, setPaymentMethod] = useState('')
  const { cartId } = useCartStore()

  const onSubmit = async (data: any) => {
    if (!!paymentMethod && !!shippingMethod) {
      startTransition(async () => {
        const dataSubmit: IPaymentMethodAndPlaceOrderPayload = {
          setPaymentMethodOnCartInput: {
            cart_id: cartId,
            payment_method: {
              code: paymentMethod,
            },
          },
          placeOrderInput: {
            cart_id: cartId,
            create_customer: false,
          },
        }
        if (isEmpty(userInfo)) {
          await setGuestEmailAction({
            input: {
              cart_id: cartId,
              email: data.email,
            },
          }).then((res) => {
            console.log('set guest email', res)
          })
        }
        setPaymentAndPlaceOrderAction(dataSubmit).then((res: any) => {
          console.log('place order:', res)
          if (res?.payload?.errors?.[0]?.message) {
            toast.error(res?.payload?.errors?.[0]?.message)
            return
          }
          if (res?.payload?.data?.placeOrder?.order?.paymentOnline?.url_page) {
            window.location.href = res?.payload?.data?.placeOrder?.order?.paymentOnline?.url_page
          } else {
            setDataPlaceOrder(res?.payload?.data?.placeOrder)
            router.push(
              '/checkout/success?payment=' +
                paymentMethod +
                '&order=' +
                res?.payload?.data?.placeOrder?.order?.order_number
            )
          }
        })
      })
    } else {
      setError('payment', {
        message: 'Vui lòng chọn phương thức thanh toán',
        type: 'error',
        types: { payment: 'Vui không chọn phương thức thanh toán' },
      })
    }
  }
  return (
    <section>
      <Form methods={method} onSubmit={handleSubmit(onSubmit)} className="w-full">
        {/* <CheckoutInfo setShippingMethod={setShippingMethod} shippingMethod={shippingMethod} /> */}

        <InforOrder
          control={control}
          setPaymentMethod={setPaymentMethod}
          isPending={isPending}
          paymentMethod={paymentMethod}
        />
      </Form>
    </section>
  )
}
